import { colors } from '../../colors';
var book = {
  fieldBorderColor: colors.smoke,
  errorColor: colors.warningRed
};
export default book;